import { render, staticRenderFns } from "./MultiTaskingWebComtent.vue?vue&type=template&id=2a7b9297&scoped=true&"
import script from "./MultiTaskingWebComtent.vue?vue&type=script&lang=js&"
export * from "./MultiTaskingWebComtent.vue?vue&type=script&lang=js&"
import style0 from "./MultiTaskingWebComtent.vue?vue&type=style&index=0&id=2a7b9297&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7b9297",
  null
  
)

export default component.exports